import { createContext, useState, useCallback, useRef } from 'react';
import PasteBranchModal from 'automation-ui-canvas/components/canvas/copyPaste/PasteBranchModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PasteActionModalContext = /*#__PURE__*/createContext({
  showPasteActionModal: () => {},
  setPastingData: () => {}
});
const PasteActionModalConsumer = PasteActionModalContext.Consumer;
export const PasteActionModalWrapper = props => {
  const [modalVisible, setModalVisibility] = useState(false);
  const onSaveRef = useRef(null);
  const [pastingData, setPastingData] = useState(null);
  const [parentAction, setParentAction] = useState(null);
  const showPasteActionModal = useCallback(() => {
    setModalVisibility(true);
  }, [setModalVisibility]);
  const hideModal = useCallback(() => {
    setModalVisibility(false);
    onSaveRef.current = null;
    setPastingData(null);
    setParentAction(null);
  }, [setModalVisibility]);
  const setPastingDataCB = useCallback((data, onSave, rootAction) => {
    const noOp = () => {};
    onSaveRef.current = onSave || noOp;
    setPastingData(data);
    setParentAction(rootAction);
  }, [setPastingData]);
  return /*#__PURE__*/_jsxs(PasteActionModalContext.Provider, {
    value: {
      showPasteActionModal,
      setPastingData: setPastingDataCB
    },
    children: [props.children, modalVisible && pastingData && /*#__PURE__*/_jsx(PasteBranchModal, {
      onSave: ({
        removeAllChildren,
        branchIndexToKeep,
        parentBranchIndex
      }) => {
        if (onSaveRef.current) onSaveRef.current({
          branchIndexToSetDownstreamActionsIn: branchIndexToKeep,
          deleteDownstreamActions: removeAllChildren,
          parentBranchIndex
        });
        hideModal();
      },
      onClose: hideModal,
      action: pastingData.action,
      flowObjectTypeId: pastingData.flowObjectTypeId,
      getActionOutputsForTargetActionById: () => [],
      parentAction: parentAction
    })]
  });
};
export function wirePasteActionModalConsumer(WrappedComponent) {
  return props => /*#__PURE__*/_jsx(PasteActionModalConsumer, {
    children: ({
      setPastingData,
      showPasteActionModal
    }) => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      setPastingData: setPastingData,
      showPasteActionModal: showPasteActionModal
    }))
  });
}